import classNames from 'classnames';
import * as React from 'react';
import { Link }   from 'react-router-dom';

function RenderButton(props) {
  const {
          action,
          className = 'primary',
          disabled,
          icon,
          label     = '',
          onClick,
          style     = {},
          target,
          type      = 'button',
          uri       = '',
        } = props;

  const commonProps = React.useMemo(() => {
    return {
      className: classNames('btn', className, { disabled }),
    };
  }, [className, disabled]);

  if (type === 'link') {
    const isExternal = /^https?/g.test(uri);
    const Component  = isExternal ? 'a' : Link;

    const linkProps = {
      [isExternal ? 'href' : 'to']: uri,
    };

    return (
      <Component
        {...commonProps}
        {...linkProps}
        onClick={(event) => {
          if (disabled) {
            event.preventDefault();
          } else {
            onClick?.(event);
          }
        }}
        style={style}
        target={target}
      >
        {typeof icon === 'object' && icon} {label}
      </Component>
    );
  }

  if (type === 'submit') {
    return (
      <button
        {...commonProps}
        disabled={disabled}
        onClick={(event) => {
          onClick?.(event);
        }}
        type={type}
      >
        {typeof icon === 'object' && icon} {label}
      </button>
    );
  }

  return (
    <span
      {...commonProps}
      onClick={(event) => {
        if (disabled) {
          event.preventDefault();
        } else {
          action(event);

          onClick?.(event);
        }
      }}
    >
      {typeof icon === 'object' && icon} {label}
    </span>
  );
}

export default RenderButton;